import HeroImage from "../assets/Image10.jpeg";

function Hero() {
  return (
    <section
      className="hero"
      style={{
        backgroundImage: `url(${HeroImage})`,
      }}
    >
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <div className="admission-badge">
          🎉 Admissions Open for 2026-27
        </div>

        <h1>
          <span className="pink">Little Steps</span>
          <br />
          <span className="blue">Big Dreams</span>
        </h1>

        <p>
          A joyful place where learning, creativity,
          friendship and confidence grow together.
        </p>
      </div>
    </section>
  );
}

export default Hero;